import _ from 'lodash';
import Vue from 'vue';
import Vuetify from 'vuetify/lib/framework';
import ko from 'vuetify/lib/locale/ko';
import Util from '@/lib/Util';

Vue.use(Vuetify);
Vue.set(Vue.prototype, '_', _);
Vue.set(Vue.prototype, 'Util', Util);

export default new Vuetify({
	lang: {
		locales: { ko },
		current: 'ko',
	},
});
